import http from 'api/Api';

class DbSnapshotsApi {
  static listMaskJobs(params) {
    return http.get('/admin/mask-jobs', { params });
  }

  static getMaskJob(id) {
    return http.get(`/admin/mask-jobs/${id}`);
  }

  static createMaskJob(data) {
    return http.post('/admin/mask-jobs', data);
  }

  static downloadMaskJob(id) {
    return http.get(`/admin/mask-jobs/${id}/download`);
  }

  static revokeMaskJob({ id, reason }) {
    return http.post(`/admin/mask-jobs/${id}/revoke`, { reason });
  }

  static retryMaskJob(id) {
    return http.post(`/admin/mask-jobs/${id}/retry`);
  }

  static searchTenants(query) {
    return http.get('/admin/mask-jobs/tenants/search', { params: { query } });
  }
}

export default DbSnapshotsApi;
